import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import { RequestNewPasswordActionTypes } from '../../actions/types';

const requestNewPassword = makeAsyncReducerHandlers(
  RequestNewPasswordActionTypes.requestNewPassword,
  (state, action) => ({
    item: state.item,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    item: { isSent: true },
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    item: state.item,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  requestNewPassword,
};
